// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='DropDown2'] {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  background-position: center right;\r\n  background-repeat: no-repeat;\r\n  background-position-x: calc(100% - 5px);\r\n  appearance: none;\r\n  padding-right: 20px;\r\n}\r\n  [name='DropDown2'] option {\r\n    font-size: 14px;\r\n    color: #7a7a7a;\r\n  }\r\n  [name='DropDown2'] option :hover {\r\n    border-radius: 25px;\r\n    background-color: #4e4a4a;\r\n  }\r\n", ""]);
// Exports
module.exports = exports;
